'use strict';

function didTabClose(tab, timeout) {
    const defer = $.Deferred();

    _.delay(function() {
        defer.resolve(!tab || tab.closed || 'undefined' === typeof tab.closed);
    }, timeout);

    return defer.promise();
}

module.exports = {
    didTabClose: didTabClose,
};
